module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-select"
  }, [_c('div', {
    staticClass: "ui item small menu",
    class: _vm.$formatters.number_to_word(_vm.items.length)
  }, _vm._l((_vm.items), function(i) {
    return _c('div', {
      staticClass: "item",
      class: {
        active: i === _vm.item
      },
      on: {
        "click": function($event) {
          _vm.select(i)
        }
      }
    }, [_vm._v(_vm._s(i.label))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb634e2c","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/src/components/filters/FilterSelect.vue
// module id = 341
// module chunks = 0